import { AuthContext } from '@context-providers/auth-context-provider'
import { RootDocument } from '@pages/root-document'
import appCss from '@styles/styles.css?url'
import { createRootRouteWithContext } from '@tanstack/react-router'

import { z } from 'zod'

type RouterContext = {
  auth: AuthContext
}

const zSharedStateParams = z.object({
  redirectUrl: z.string().optional(),
})

export type AppSearchParams = z.infer<typeof zSharedStateParams>

/**
 * all routes are rendered with auth context
 * for fav icons see
 * https://favicon.io/favicon-converter/
 * https://favicon.io/tutorials/
 *
 * removed all other images than favicon.ico to simplify
 */
export const Route = createRootRouteWithContext<RouterContext>()({
  head: () => ({
    meta: [
      {
        charSet: 'utf-8',
      },
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1',
      },
      {
        name: 'robots',
        content: 'noindex, nofollow',
      },
      {
        title: 'Portfolio Excellence',
      },
      {
        name: 'description',
        content: 'Portfolio Excellence',
      },
    ],
    links: [
      {
        rel: 'stylesheet',
        href: appCss,
      },
      {
        rel: 'icon',
        type: 'image/x-icon',
        href: '/favicon.ico',
      },
      {
        rel: 'manifest',
        href: '/site.webmanifest',
      },
    ],
  }),
  shellComponent: RootDocument,
  validateSearch: zSharedStateParams,
})
